/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: WsKrqHiP5PVH
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonNav from "../../ButtonNav"; // plasmic-import: 1_lRcjfh8CEO/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebsiteDock.module.css"; // plasmic-import: WsKrqHiP5PVH/css
import Icon29Icon from "./icons/PlasmicIcon__Icon29"; // plasmic-import: AFzBqeF1A0gq/icon
import image53E5CMmWHg03Qf from "./images/image53.svg"; // plasmic-import: e5CMmWHg03Qf/picture

createPlasmicElementProxy;

export const PlasmicOp1WebsiteDock__VariantProps = new Array();

export const PlasmicOp1WebsiteDock__ArgProps = new Array(
  "spacesGoHere",
  "appsWindoesGoHere"
);

const $$ = {};

function PlasmicOp1WebsiteDock__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"dock"}
      data-plasmic-override={overrides.dock}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.dock
      )}
      onMouseEnter={async event => {
        const $steps = {};
      }}
      onMouseLeave={async event => {
        const $steps = {};
      }}
    >
      <div
        data-plasmic-name={"logoWrapper"}
        data-plasmic-override={overrides.logoWrapper}
        className={classNames("all", sty.logoWrapper)}
      >
        <Icon29Icon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames("all", sty.svg)}
          role={"img"}
        />
      </div>
      <div
        data-plasmic-name={"separatorWrapper"}
        data-plasmic-override={overrides.separatorWrapper}
        className={classNames("all", sty.separatorWrapper)}
      >
        <div className={classNames("all", sty.freeBox__yxZ27)} />
      </div>
      <div
        data-plasmic-name={"spaces"}
        data-plasmic-override={overrides.spaces}
        className={classNames("all", sty.spaces)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.spacesGoHere
        })}
      </div>
      <div
        data-plasmic-name={"separatorWrapper2"}
        data-plasmic-override={overrides.separatorWrapper2}
        className={classNames("all", sty.separatorWrapper2)}
      >
        <div className={classNames("all", sty.freeBox__y7Pif)} />
      </div>
      <div
        data-plasmic-name={"appWindows"}
        data-plasmic-override={overrides.appWindows}
        className={classNames("all", sty.appWindows)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.appsWindoesGoHere
        })}
      </div>
      <div
        data-plasmic-name={"separatorWrapper3"}
        data-plasmic-override={overrides.separatorWrapper3}
        className={classNames("all", sty.separatorWrapper3)}
      >
        <div className={classNames("all", sty.freeBox___89H)} />
      </div>
      <div
        data-plasmic-name={"loginWrapper"}
        data-plasmic-override={overrides.loginWrapper}
        className={classNames("all", sty.loginWrapper)}
      >
        <ButtonNav
          data-plasmic-name={"buttonNav"}
          data-plasmic-override={overrides.buttonNav}
          className={classNames("__wab_instance", sty.buttonNav)}
          color={"transparentBg"}
          iconForButton={
            <PlasmicImg__
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"100%"}
              displayMaxHeight={"none"}
              displayMaxWidth={"none"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"100%"}
              loading={"lazy"}
              src={{
                src: image53E5CMmWHg03Qf,
                fullWidth: 20,
                fullHeight: 20,
                aspectRatio: undefined
              }}
            />
          }
          onClick={async () => {
            const $steps = {};
            $steps["goToAccountLogin"] = true
              ? (() => {
                  const actionArgs = { destination: `/account/login` };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      location.assign(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToAccountLogin"] != null &&
              typeof $steps["goToAccountLogin"] === "object" &&
              typeof $steps["goToAccountLogin"].then === "function"
            ) {
              $steps["goToAccountLogin"] = await $steps["goToAccountLogin"];
            }
          }}
          shape={"globalRounding"}
          status={"normal"}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  dock: [
    "dock",
    "logoWrapper",
    "svg",
    "separatorWrapper",
    "spaces",
    "separatorWrapper2",
    "appWindows",
    "separatorWrapper3",
    "loginWrapper",
    "buttonNav",
    "img"
  ],

  logoWrapper: ["logoWrapper", "svg"],
  svg: ["svg"],
  separatorWrapper: ["separatorWrapper"],
  spaces: ["spaces"],
  separatorWrapper2: ["separatorWrapper2"],
  appWindows: ["appWindows"],
  separatorWrapper3: ["separatorWrapper3"],
  loginWrapper: ["loginWrapper", "buttonNav", "img"],
  buttonNav: ["buttonNav", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebsiteDock__ArgProps,
          internalVariantPropNames: PlasmicOp1WebsiteDock__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebsiteDock__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "dock") {
    func.displayName = "PlasmicOp1WebsiteDock";
  } else {
    func.displayName = `PlasmicOp1WebsiteDock.${nodeName}`;
  }
  return func;
}

export const PlasmicOp1WebsiteDock = Object.assign(
  // Top-level PlasmicOp1WebsiteDock renders the root element
  makeNodeComponent("dock"),
  {
    // Helper components rendering sub-elements
    logoWrapper: makeNodeComponent("logoWrapper"),
    svg: makeNodeComponent("svg"),
    separatorWrapper: makeNodeComponent("separatorWrapper"),
    spaces: makeNodeComponent("spaces"),
    separatorWrapper2: makeNodeComponent("separatorWrapper2"),
    appWindows: makeNodeComponent("appWindows"),
    separatorWrapper3: makeNodeComponent("separatorWrapper3"),
    loginWrapper: makeNodeComponent("loginWrapper"),
    buttonNav: makeNodeComponent("buttonNav"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicOp1WebsiteDock
    internalVariantProps: PlasmicOp1WebsiteDock__VariantProps,
    internalArgProps: PlasmicOp1WebsiteDock__ArgProps
  }
);

export default PlasmicOp1WebsiteDock;
/* prettier-ignore-end */
